import {
  contactsDestroyMutation,
  leadsContactsListQueryKey,
  opportunitiesContactsListQueryKey
} from '@crm/api'
import { ConfirmModal } from '@crm/components'
import { useInvalidatePredicateQueries } from '@shared/hooks'
import { showApiErrors } from '@shared/utils'

import { useMutation } from '@tanstack/react-query'

import { useParams } from 'react-router-dom'

import { ActionsType } from './types'

export const DeleteLead = ({ lead, onCancel, ...props }: ActionsType) => {
  const { invalidateQueries } = useInvalidatePredicateQueries()

  const { id: leadId, opportunityId } = useParams()

  const { mutate, isPending } = useMutation({
    ...contactsDestroyMutation(),
    onSuccess: () => {
      invalidateQueries([
        leadsContactsListQueryKey({ path: { lead_id: String(leadId) } })
      ])

      if (opportunityId) {
        invalidateQueries([
          opportunitiesContactsListQueryKey({
            path: { opportunity_id: String(opportunityId) }
          })
        ])
      }

      onCancel?.()
    },
    onError: (error) => showApiErrors(error)
  })

  const onDelete = () => {
    if (!lead.id) return

    mutate({ path: { id: lead.id } })
  }

  return (
    <ConfirmModal
      loading={isPending}
      onSuccess={onDelete}
      onCancel={onCancel}
      {...props}
    />
  )
}
